export default __webpack_public_path__ + "static/media/Division_07.7123d830.png";